import { useQuery } from "@apollo/client";
import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React, { ReactElement } from "react";

import { Template } from "../../generated/gql/graphql";
import { GetTemplatesGQL } from "../../hooks/use-templates";

type Props = {
  templateId: string | null;
  title: string;
  onTemplateIdChange: (templateId: string | null) => void;
};

export default function TemplateSelector(props: Props): ReactElement {
  const { templateId, title, onTemplateIdChange } = props;
  const { data } = useQuery(GetTemplatesGQL, {
    fetchPolicy: "network-only",
  });
  const templates: Pick<Template, "id" | "name">[] =
    data?.templates?.items ?? [];

  const handleChange = (event: SelectChangeEvent): void => {
    const value = event.target.value;
    onTemplateIdChange(value === "" ? null : value);
  };

  return (
    <div>
      <div className="font-bold text-[16px] mb-[6px] text-[#4A4A4A]">
        Project
      </div>
      <Select
        size="small"
        className="border-0 text-left text-[14px] w-[50%]"
        value={templateId ?? ""}
        onChange={handleChange}
      >
        <MenuItem value="">
          <em>No template</em>
        </MenuItem>
        {templates.map((t) => (
          <MenuItem key={t.id} value={t.id}>
            {t.name}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}
